import React, {useReducer} from "react";
import PropTypes from "prop-types";

import Paper from "@mui/material/Paper";
import IconButton from "@mui/material/IconButton";
import SearchIcon from "@mui/icons-material/Search";
import Collapse from "@mui/material/Collapse";
import InputBase from "@mui/material/InputBase";
import Divider from "@mui/material/Divider";
import TuneIcon from "@mui/icons-material/Tune";
import Box from "@mui/material/Box";

// TODO can be moved outside as a general component
const SearchTools = (props) => {
    const {children, InputBaseProps} = props
    const [filterOpen, toggleFilterOpen] = useReducer(state => !state, false);

    return <>
        <Paper
            elevation={0}
            sx={{p: '2px 4px', display: 'flex', alignItems: 'center'}}>
            <IconButton sx={{p: '10px'}}>
                <SearchIcon/>
            </IconButton>
            <InputBase {...{
                sx: {ml: 1, flex: 1},
                ...InputBaseProps
            }}
            />
            {
                !!children && <>
                    <Divider sx={{height: 28, m: 0.5}} orientation="vertical"/>
                    <IconButton color='primary' sx={{p: '10px'}} onClick={toggleFilterOpen}>
                        <TuneIcon/>
                    </IconButton>
                </>
            }

        </Paper>
        {
            !!children && <Collapse in={filterOpen}>
                <Divider/>
                <Box p="16px 8px">
                {
                    children
                }
                </Box>
            </Collapse>
        }
    </>
}

SearchTools.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node
    ]),  // node children to display in the collapsable box
    InputBaseProps: PropTypes.object // Any prop accepted by the InputBase mui component
}

export default SearchTools;